import * as React from "react";
import Questionnaire from "./Questionnaire";
import { number } from "prop-types";
import CollapsiblePanel from "../CollapsiblePanel";
import AppUtils from "../../utils/AppUtils";
import { ORION_IMG_URL } from "../../utils/AppConstants";

interface QuestionnaireListProps {
    type: any;
    validations: any;
    listItems: any[];
    showCollapasable?: any;
    updateHandler: (updatedObject: any, key: string, index: number) => void;
    templatedListChange?: (updatedValue: any, index: number, key: string) => void;
    templatedListValidations?: (value: any, index: number, key: string) => void;
    templatedListRemoved?: (index: number, key: string) => void;
    updateQuestionnaireList: (listItems: any[], questionKey: string) => void;
    isViewOnly?: boolean
}

interface QuestionnaireListStates {
    questionnaireItems: any;
    uiConfigData: any;
    listShowItems: any;
}



export default class QuestionnaireList extends React.Component<QuestionnaireListProps, QuestionnaireListStates> {
    constructor(props: QuestionnaireListProps) {
        super(props);
        this.state = {
            questionnaireItems: [],
            uiConfigData: [],
            listShowItems: []
        }
    }

    componentDidMount() {
        const questionnaireItems = this.props.listItems && this.props.listItems.length > 0 ?
            this.props.listItems.map((items) => {
                return { "data": this.props.type.data };
            }) : [{ "data": this.props.type.data }];
        this.setState({ questionnaireItems });
    }

    templatedListChange = (updatedValue: any, key: string, index: number, questionKey: string, questionIndex: number) => {
        const listItems = [...this.props.listItems];
        let updatedObject = listItems[questionIndex] ? listItems[questionIndex] : {};
        if (updatedObject[key]) {
            if (!updatedObject[key][index]) {
                updatedObject[key].push(updatedValue.item);
            } else {
                updatedObject[key][index] = updatedValue.item;
            }
        } else {
            updatedObject[key] = [];
            updatedObject[key][index] = updatedValue.item;
        }
        this.props.updateHandler(updatedObject, questionKey, questionIndex);
    }

    templatedListRemoved = (index: any, key: string, questionIndex: number, questionKey: string) => {
        let listItems = [...this.props.listItems];
        let updatedObject = listItems[questionIndex];
        updatedObject[key].splice(index, 1);
        this.props.updateHandler(updatedObject, questionKey, questionIndex);
    }

    updateHandler = (value: any, key: string, questionIndex: number, questionKey: string) => {
        let listItems = [...this.props.listItems];
        let updatedObject = listItems[questionIndex] ? listItems[questionIndex] : {};
        updatedObject[key] = value;
        this.props.updateHandler(updatedObject, questionKey, questionIndex);
    }

    validationHandler = (value: any, key: string, questionIndex: number, questionKey: string) => {
        console.log("validation will go here");
    }

    addNew = () => {
        let questionnaireItems = [...this.state.questionnaireItems];
        let { type } = this.props;
        questionnaireItems.push({ "data": type.data });
        this.setState({ questionnaireItems });
    }

    remove = (index: number, questionKey: string) => {
        let listItems = [...this.props.listItems];
        let questionnaireItems = [...this.state.questionnaireItems];
        if (questionnaireItems.length !== 1) {
            questionnaireItems.splice(index, 1);
            this.setState({ questionnaireItems });
        }
        listItems.splice(index, 1);
        this.props.updateQuestionnaireList(listItems, questionKey);
    }

    renderComponent = (list: any, questionIndex: any) => {
        const { type, listItems } = this.props;
        return <div className="questionnaire-list">
            {list.data.map((dataObj: any, index: number) => {
                let key = dataObj.key;
                dataObj.isViewOnly = this.props.isViewOnly;
                let answer = key && listItems && listItems[questionIndex] && listItems[questionIndex][key] ? listItems[questionIndex][key] : null;
                let validationText = this.props.validations && this.props.validations[type.key] ? this.props.validations[type.key] : null;
                
                return <Questionnaire key={index} question={dataObj} answer={answer}
                    hideComment={dataObj.hideComment ? dataObj.hideComment : true}
                    validationText={validationText}
                    templatedListChange={(updatedValue: any, listIndex: number, key: string) => this.templatedListChange(updatedValue, key, listIndex, type.key, questionIndex)}
                    templatedListRemoved={(listIndex: number, key: string) => this.templatedListRemoved(listIndex, key, questionIndex, type.key)}
                    templatedListValidations={this.props.templatedListValidations}
                    updateHandler={(value: any, key: string) => this.updateHandler(value, key, questionIndex, type.key)}
                    validationHandler={(value: any, key: string) => this.validationHandler(value, key, questionIndex, type.key)}
                />
            })}
        </div>
    }

    render() {
        const { type, listItems } = this.props;
        let { questionnaireItems } = this.state;
        return <div className="questionnaire-list-container">
            {questionnaireItems.map((list: any, questionIndex: number) => {
              let title = listItems && listItems[questionIndex] && listItems[questionIndex][list.data[0].key] && listItems[questionIndex][list.data[0].key].displayValue ? listItems[questionIndex][list.data[0].key].displayValue : "Select Trouble"

                if (!AppUtils.isDefined(type.showCollapasable)) type.showCollapasable = true;
                let ShowComponent = this.renderComponent(list, questionIndex);
                return type.showCollapasable === false ? ShowComponent : <div className="questionnaire-list-wrapper" key={questionIndex}>
                    <CollapsiblePanel key={questionIndex}>
                        <div className="collapsible-heading">{title}</div>
                        {ShowComponent}
                    </CollapsiblePanel>
                    <div className="remove-questionnaire-item" onClick={() => this.remove(questionIndex, type.key)}>
                        <img src={ORION_IMG_URL + "remove-icon.png"} />
                    </div>
                </div>
            })}
            {type.showCollapasable && listItems && listItems[questionnaireItems.length - 1] && <input type="button" value={"+ Add Pain History"} onClick={this.addNew} />}
        </div>
    }
}

// docs app physio branch backup 22-04-19